module.exports = __webpack_public_path__ + "static/media/w (44).f4ec3c05.jpg";